import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-column" }
const _hoisted_2 = { class: "d-flex flex-column" }
const _hoisted_3 = { class: "d-flex align-center" }
const _hoisted_4 = { class: "mr-n2" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "link" }
const _hoisted_7 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_8 = {
  key: 1,
  class: "d-flex"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "text-primary" }, "Exit account", -1)
const _hoisted_10 = { class: "d-flex justify-end" }
const _hoisted_11 = { class: "d-flex flex-column" }
const _hoisted_12 = { class: "d-flex flex-column" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, " Account details ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_action = _resolveComponent("v-list-item-action")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_combobox = _resolveComponent("v-combobox")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_color_picker = _resolveComponent("v-color-picker")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_row, {
      justify: "space-between",
      align: "center",
      dense: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              align: "center",
              dense: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      color: "#F4F4F4",
                      class: "pa-2 align-content-center",
                      variant: "flat",
                      height: "48"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, {
                          dense: "",
                          align: "center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "8" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, {
                                  "no-gutters": "",
                                  align: "center"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "3",
                                      md: "auto"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_dialog, {
                                          width: "500",
                                          onAfterLeave: _cache[2] || (_cache[2] = ($event: any) => {_ctx.tenant.name = ''; _ctx.applicationsToRegister = [];})
                                        }, {
                                          activator: _withCtx(({ props }) => [
                                            _createVNode(_component_v_btn, _mergeProps(props, {
                                              size: "small",
                                              variant: "plain",
                                              color: "primary"
                                            }), {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.mdAndUp ? 'Add account' : 'Add'), 1)
                                              ]),
                                              _: 2
                                            }, 1040)
                                          ]),
                                          default: _withCtx(({ isActive }) => [
                                            _createVNode(_component_v_card, { title: "Add an account" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_card_text, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_form, null, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_row, null, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_col, { cols: "12" }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_v_text_field, {
                                                                  "hide-details": "",
                                                                  density: "compact",
                                                                  label: "Name",
                                                                  modelValue: _ctx.tenant.name,
                                                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tenant.name) = $event))
                                                                }, null, 8, ["modelValue"])
                                                              ]),
                                                              _: 1
                                                            })
                                                          ]),
                                                          _: 1
                                                        }),
                                                        _createVNode(_component_v_row, { align: "center" }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_col, {
                                                              cols: "12",
                                                              class: "pb-0"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_v_btn, {
                                                                  block: "",
                                                                  rounded: "pill",
                                                                  color: "primary",
                                                                  variant: "flat",
                                                                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addApplicationRow(_ctx.tenant))),
                                                                  disabled: !_ctx.filteredApplications.length
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createTextVNode(" Add application ")
                                                                  ]),
                                                                  _: 1
                                                                }, 8, ["disabled"])
                                                              ]),
                                                              _: 1
                                                            }),
                                                            _createVNode(_component_v_col, {
                                                              cols: "12",
                                                              class: "pt-0"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_v_list, null, {
                                                                  default: _withCtx(() => [
                                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.applicationsToRegister, (app) => {
                                                                      return (_openBlock(), _createBlock(_component_v_list_item, {
                                                                        key: app.name,
                                                                        style: {"background-color":"rgba(0,0,0,0.05)"},
                                                                        rounded: "",
                                                                        class: "my-2"
                                                                      }, {
                                                                        default: _withCtx(() => [
                                                                          _createVNode(_component_v_row, {
                                                                            "no-gutters": "",
                                                                            justify: "space-between",
                                                                            align: "center"
                                                                          }, {
                                                                            default: _withCtx(() => [
                                                                              _createVNode(_component_v_col, { cols: "11" }, {
                                                                                default: _withCtx(() => [
                                                                                  _createVNode(_component_v_list_item_title, null, {
                                                                                    default: _withCtx(() => [
                                                                                      _createTextVNode(_toDisplayString(app.name), 1)
                                                                                    ]),
                                                                                    _: 2
                                                                                  }, 1024),
                                                                                  _createVNode(_component_v_list_item_subtitle, null, {
                                                                                    default: _withCtx(() => [
                                                                                      _createTextVNode(_toDisplayString(app.description), 1)
                                                                                    ]),
                                                                                    _: 2
                                                                                  }, 1024)
                                                                                ]),
                                                                                _: 2
                                                                              }, 1024),
                                                                              _createVNode(_component_v_col, { cols: "1" }, {
                                                                                default: _withCtx(() => [
                                                                                  _createVNode(_component_v_list_item_action, null, {
                                                                                    default: _withCtx(() => [
                                                                                      _createVNode(_component_v_btn, {
                                                                                        icon: "",
                                                                                        variant: "flat",
                                                                                        color: "transparent",
                                                                                        size: "32",
                                                                                        onClick: ($event: any) => (_ctx.removeNewApplication(app))
                                                                                      }, {
                                                                                        default: _withCtx(() => [
                                                                                          _createVNode(_component_v_icon, {
                                                                                            icon: "mdi-delete",
                                                                                            color: "primary",
                                                                                            size: "24"
                                                                                          })
                                                                                        ]),
                                                                                        _: 2
                                                                                      }, 1032, ["onClick"])
                                                                                    ]),
                                                                                    _: 2
                                                                                  }, 1024)
                                                                                ]),
                                                                                _: 2
                                                                              }, 1024)
                                                                            ]),
                                                                            _: 2
                                                                          }, 1024)
                                                                        ]),
                                                                        _: 2
                                                                      }, 1024))
                                                                    }), 128)),
                                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newApps, (app) => {
                                                                      return (_openBlock(), _createBlock(_component_v_list_item, {
                                                                        class: "mb-1 px-0 pt-0",
                                                                        key: app.name
                                                                      }, {
                                                                        default: _withCtx(() => [
                                                                          _createVNode(_component_v_combobox, {
                                                                            class: "app-combobox",
                                                                            clearable: "",
                                                                            items: _ctx.filteredApplications,
                                                                            "item-title": "name",
                                                                            "hide-details": "",
                                                                            density: "comfortable",
                                                                            placeholder: "Search applications",
                                                                            "return-object": "",
                                                                            "menu-props": { maxWidth: 452 }
                                                                          }, {
                                                                            selection: _withCtx(({ item }) => [
                                                                              _createElementVNode("div", _hoisted_1, [
                                                                                _createVNode(_component_v_list_item_title, null, {
                                                                                  default: _withCtx(() => [
                                                                                    _createTextVNode(_toDisplayString(item.raw.name), 1)
                                                                                  ]),
                                                                                  _: 2
                                                                                }, 1024),
                                                                                _createVNode(_component_v_list_item_subtitle, null, {
                                                                                  default: _withCtx(() => [
                                                                                    _createTextVNode(_toDisplayString(item.raw.description), 1)
                                                                                  ]),
                                                                                  _: 2
                                                                                }, 1024)
                                                                              ])
                                                                            ]),
                                                                            item: _withCtx(({ item }) => [
                                                                              _createElementVNode("div", _hoisted_2, [
                                                                                _createVNode(_component_v_list_item, {
                                                                                  onClick: ($event: any) => {_ctx.newApp = item.raw; _ctx.addApplicationAccess()}
                                                                                }, {
                                                                                  default: _withCtx(() => [
                                                                                    _createVNode(_component_v_list_item_title, null, {
                                                                                      default: _withCtx(() => [
                                                                                        _createTextVNode(_toDisplayString(item.raw.name), 1)
                                                                                      ]),
                                                                                      _: 2
                                                                                    }, 1024),
                                                                                    _createVNode(_component_v_list_item_subtitle, null, {
                                                                                      default: _withCtx(() => [
                                                                                        _createTextVNode(_toDisplayString(item.raw.description), 1)
                                                                                      ]),
                                                                                      _: 2
                                                                                    }, 1024)
                                                                                  ]),
                                                                                  _: 2
                                                                                }, 1032, ["onClick"])
                                                                              ])
                                                                            ]),
                                                                            _: 1
                                                                          }, 8, ["items"])
                                                                        ]),
                                                                        _: 2
                                                                      }, 1024))
                                                                    }), 128))
                                                                  ]),
                                                                  _: 1
                                                                })
                                                              ]),
                                                              _: 1
                                                            })
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_card_actions, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_btn, {
                                                      loading: _ctx.loading,
                                                      disabled: _ctx.loading,
                                                      color: "primary",
                                                      onClick: ($event: any) => {isActive.value = false;}
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(" Cancel ")
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["loading", "disabled", "onClick"]),
                                                    _createVNode(_component_v_spacer),
                                                    _createVNode(_component_v_btn, {
                                                      loading: _ctx.loading,
                                                      disabled: !_ctx.tenant.name || _ctx.loading,
                                                      color: "primary",
                                                      onClick: ($event: any) => {_ctx.addTenant(); isActive.value = false}
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(" Add account ")
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["loading", "disabled", "onClick"])
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "4",
                                      md: "auto"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_btn, {
                                          size: "small",
                                          variant: "plain",
                                          disabled: !_ctx.selectedTenants.length,
                                          color: "primary",
                                          onClick: _ctx.toggleSuspendTenant
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString((_ctx.mdAndUp ? (_ctx.selectedTenants.length && _ctx.selectedTenants[0].state === 'active' ? 'Suspend account' : 'Activate account') : (_ctx.selectedTenants.length && _ctx.selectedTenants[0].state === 'active' ? 'Suspend' : 'Activate'))), 1)
                                          ]),
                                          _: 1
                                        }, 8, ["disabled", "onClick"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "4",
                                      md: "auto"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_dialog, { width: "500" }, {
                                          activator: _withCtx(({ props }) => [
                                            _createVNode(_component_v_btn, _mergeProps(props, {
                                              size: "small",
                                              variant: "plain",
                                              disabled: !_ctx.selectedTenants.length,
                                              color: "primary"
                                            }), {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.mdAndUp ? 'Remove account' : 'Remove'), 1)
                                              ]),
                                              _: 2
                                            }, 1040, ["disabled"])
                                          ]),
                                          default: _withCtx(({ isActive }) => [
                                            _createVNode(_component_v_card, { "max-width": "460" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_card_title, null, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode("Remove " + _toDisplayString(_ctx.selectedTenants[0]?.name || 'account') + "?", 1)
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_card_text, null, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(" Are you sure you want to remove this account? ")
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_card_actions, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_spacer),
                                                    _createVNode(_component_v_btn, {
                                                      onClick: ($event: any) => (isActive.value = false)
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(" Cancel ")
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["onClick"]),
                                                    _createVNode(_component_v_btn, {
                                                      loading: _ctx.loading,
                                                      disabled: _ctx.loading,
                                                      color: "primary",
                                                      onClick: ($event: any) => {_ctx.removeTenant(); isActive.value = false}
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(" Remove ")
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["loading", "disabled", "onClick"])
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_data_table, {
      loading: _ctx.loading,
      color: "primary",
      items: _ctx.tenants,
      headers: _ctx.headers,
      "items-per-page": 50,
      "show-select": "",
      modelValue: _ctx.selectedTenants,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedTenants) = $event)),
      "return-object": "",
      height: "calc(100vh - 280px)",
      "fixed-header": ""
    }, {
      [`item.applications`]: _withCtx(({ item }) => [
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.applications, (app, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "d-flex",
              key: app.id
            }, [
              _createElementVNode("div", _hoisted_4, [
                (index < 5)
                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                      key: 0,
                      text: app.name,
                      location: "bottom",
                      "open-delay": "200"
                    }, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_btn, _mergeProps(props, {
                          size: "32",
                          style: {"border":"2px solid #ffffff"},
                          icon: "",
                          variant: "flat",
                          color: "primary",
                          onClick: ($event: any) => {_ctx.currentTenant = {...item}; _ctx.currentApplication = app; _ctx.removeDialog = true;}
                        }), {
                          default: _withCtx(() => [
                            (!app.icon)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(app.name.charAt(0)), 1))
                              : (_openBlock(), _createBlock(_component_v_icon, {
                                  key: 1,
                                  color: "white",
                                  size: "18"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("mdi-" + _toDisplayString(app.icon), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                          ]),
                          _: 2
                        }, 1040, ["onClick"])
                      ]),
                      _: 2
                    }, 1032, ["text"]))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128)),
          (item.applications.length > 5)
            ? (_openBlock(), _createBlock(_component_v_tooltip, {
                key: 0,
                location: "bottom",
                "open-delay": "200"
              }, {
                activator: _withCtx(({ props }) => [
                  _createElementVNode("div", _mergeProps(props, { class: "ml-4" }), [
                    _createElementVNode("a", _hoisted_6, "+ " + _toDisplayString(item.applications.length - 5) + " more", 1)
                  ], 16)
                ]),
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.applications.slice(5), (app) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: app.id
                    }, _toDisplayString(app.name), 1))
                  }), 128))
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true)
        ])
      ]),
      [`item.state`]: _withCtx(({ item }) => [
        (item.state === 'active')
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_v_icon, {
                start: "",
                icon: "mdi-circle",
                color: "success"
              }),
              _createTextVNode(" Active ")
            ]))
          : _createCommentVNode("", true),
        (item.state === 'suspended')
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_component_v_icon, {
                start: "",
                icon: "mdi-circle",
                color: "amber"
              }),
              _createTextVNode(" Suspended ")
            ]))
          : _createCommentVNode("", true)
      ]),
      [`item.access`]: _withCtx(({ item }) => [
        (item.state !== 'suspended' && item.id !== _ctx.tenantStore.tenantId)
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 0,
              width: "168",
              size: "small",
              height: "32",
              variant: "flat",
              rounded: "pill",
              onClick: ($event: any) => (_ctx.manageTenant(item, item.id)),
              color: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Access account "),
                _createVNode(_component_v_icon, { end: "" }, {
                  default: _withCtx(() => [
                    _createTextVNode("mdi-arrow-right")
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["onClick"]))
          : (item.id === _ctx.tenantStore.tenantId)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 1,
                width: "168",
                size: "small",
                height: "32",
                variant: "flat",
                rounded: "pill",
                onClick: ($event: any) => (_ctx.clearTenant(item.id)),
                color: "#f4f4f4"
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : _createCommentVNode("", true)
      ]),
      [`item.actions`]: _withCtx(({ item }) => [
        _createVNode(_component_v_menu, null, {
          activator: _withCtx(({ props }) => [
            _createElementVNode("div", _hoisted_10, [
              (item.state !== 'suspended')
                ? (_openBlock(), _createBlock(_component_v_btn, _mergeProps({ key: 0 }, props, {
                    size: "32",
                    icon: "",
                    variant: "flat",
                    color: "primary"
                  }), {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { size: "20" }, {
                        default: _withCtx(() => [
                          _createTextVNode("mdi-dots-vertical")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1040))
                : _createCommentVNode("", true)
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_v_list, { density: "compact" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list_item, {
                  onClick: ($event: any) => {_ctx.currentTenant = {...item}; _ctx.editAccount(item);},
                  "prepend-icon": "mdi-pencil",
                  title: "Edit account"
                }, null, 8, ["onClick"]),
                _createVNode(_component_v_list_item, {
                  onClick: ($event: any) => {_ctx.currentTenant = {...item}; _ctx.editApplicationDialog = true;},
                  "prepend-icon": "mdi-application-edit",
                  title: "Edit applications"
                }, null, 8, ["onClick"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024)
      ]),
      _: 2
    }, 1032, ["loading", "items", "headers", "modelValue"]),
    _createVNode(_component_v_dialog, {
      width: "500",
      modelValue: _ctx.removeDialog,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.removeDialog) = $event))
    }, {
      default: _withCtx(({ isActive }) => [
        _createVNode(_component_v_card, { "max-width": "460" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode("Remove " + _toDisplayString(_ctx.currentApplication.name) + " from " + _toDisplayString(_ctx.currentTenant.name) + "?", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createTextVNode(" Are you sure you want to remove this application from this account? Users in this account will no longer have access to the application or its data. ")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  onClick: ($event: any) => (isActive.value = false)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Cancel ")
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_v_btn, {
                  loading: _ctx.loading,
                  disabled: _ctx.loading,
                  color: "primary",
                  onClick: ($event: any) => {_ctx.unregisterApplication(_ctx.currentApplication, true); isActive.value = false}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Remove ")
                  ]),
                  _: 2
                }, 1032, ["loading", "disabled", "onClick"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      width: "500",
      modelValue: _ctx.editApplicationDialog,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.editApplicationDialog) = $event)),
      onAfterLeave: _cache[8] || (_cache[8] = ($event: any) => {_ctx.applicationsToRegister = []; _ctx.currentTenant = null})
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { title: "And or remove account applications" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_form, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { align: "center" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          class: "pb-0"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              block: "",
                              rounded: "pill",
                              color: "primary",
                              variant: "flat",
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addApplicationRow(_ctx.currentTenant))),
                              disabled: !_ctx.filteredApplications.length
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Add application")
                              ]),
                              _: 1
                            }, 8, ["disabled"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          class: "pt-0"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list, null, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentTenant?.applications, (app) => {
                                  return (_openBlock(), _createBlock(_component_v_list_item, {
                                    key: app.name,
                                    style: {"background-color":"rgba(0,0,0,0.05)"},
                                    rounded: "",
                                    class: "my-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_row, {
                                        "no-gutters": "",
                                        class: "flex-nowrap",
                                        justify: "space-between",
                                        align: "center"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, { cols: "11" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item_title, null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(app.name), 1)
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _createVNode(_component_v_list_item_subtitle, null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(app.description), 1)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_v_col, { cols: "1" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item_action, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_dialog, { attach: true }, {
                                                    activator: _withCtx(({ props }) => [
                                                      _createVNode(_component_v_btn, _mergeProps(props, {
                                                        icon: "",
                                                        variant: "flat",
                                                        color: "transparent",
                                                        size: "32"
                                                      }), {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_icon, {
                                                            icon: "mdi-delete",
                                                            color: "primary",
                                                            size: "24"
                                                          })
                                                        ]),
                                                        _: 2
                                                      }, 1040)
                                                    ]),
                                                    default: _withCtx(({ isActive }) => [
                                                      _createVNode(_component_v_card, {
                                                        "max-width": "460",
                                                        "min-height": "245"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_card_title, null, {
                                                            default: _withCtx(() => [
                                                              _createTextVNode("Remove application from account")
                                                            ]),
                                                            _: 1
                                                          }),
                                                          _createVNode(_component_v_card_text, null, {
                                                            default: _withCtx(() => [
                                                              _createTextVNode(" Are you sure you want to remove this application from this account? Users in this account will no longer have access to the application or its data. ")
                                                            ]),
                                                            _: 1
                                                          }),
                                                          _createVNode(_component_v_card_actions, null, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_v_spacer),
                                                              _createVNode(_component_v_btn, {
                                                                onClick: ($event: any) => (isActive.value = false)
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode(" Cancel ")
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["onClick"]),
                                                              _createVNode(_component_v_btn, {
                                                                loading: _ctx.loading,
                                                                disabled: _ctx.loading,
                                                                color: "primary",
                                                                onClick: ($event: any) => {_ctx.unregisterApplication(app); isActive.value = false}
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode(" Remove ")
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["loading", "disabled", "onClick"])
                                                            ]),
                                                            _: 2
                                                          }, 1024)
                                                        ]),
                                                        _: 2
                                                      }, 1024)
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.applicationsToRegister, (app) => {
                                  return (_openBlock(), _createBlock(_component_v_list_item, {
                                    key: app.name,
                                    style: {"background-color":"rgba(0,0,0,0.05)"},
                                    rounded: "",
                                    class: "my-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_row, {
                                        "no-gutters": "",
                                        justify: "space-between",
                                        align: "center"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, { cols: "11" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item_title, null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(app.name), 1)
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _createVNode(_component_v_list_item_subtitle, null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(app.description), 1)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_v_col, { cols: "1" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item_action, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_btn, {
                                                    icon: "",
                                                    variant: "flat",
                                                    color: "transparent",
                                                    size: "32",
                                                    onClick: ($event: any) => (_ctx.removeNewApplication(app))
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_icon, {
                                                        icon: "mdi-delete",
                                                        color: "primary",
                                                        size: "24"
                                                      })
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["onClick"])
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newApps, (app) => {
                                  return (_openBlock(), _createBlock(_component_v_list_item, {
                                    class: "mb-1 px-0 pt-0",
                                    key: app.name
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_combobox, {
                                        class: "app-combobox",
                                        clearable: "",
                                        items: _ctx.filteredApplications,
                                        "item-title": "name",
                                        "hide-details": "",
                                        density: "comfortable",
                                        placeholder: "Search applications",
                                        "return-object": "",
                                        "menu-props": { maxWidth: 452 }
                                      }, {
                                        selection: _withCtx(({ item }) => [
                                          _createElementVNode("div", _hoisted_11, [
                                            _createVNode(_component_v_list_item_title, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(item.raw.name), 1)
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_component_v_list_item_subtitle, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(item.raw.description), 1)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ])
                                        ]),
                                        item: _withCtx(({ item }) => [
                                          _createElementVNode("div", _hoisted_12, [
                                            _createVNode(_component_v_list_item, {
                                              onClick: ($event: any) => {_ctx.newApp = item.raw; _ctx.addApplicationAccess()}
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, null, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(item.raw.name), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_v_list_item_subtitle, null, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(item.raw.description), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"])
                                          ])
                                        ]),
                                        _: 1
                                      }, 8, ["items"])
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  color: "primary",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => {_ctx.editApplicationDialog = false;}),
                  loading: _ctx.loading,
                  disabled: _ctx.loading
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Cancel ")
                  ]),
                  _: 1
                }, 8, ["loading", "disabled"]),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  color: "primary",
                  onClick: _ctx.saveTenant,
                  loading: _ctx.loading,
                  disabled: _ctx.loading
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Save account ")
                  ]),
                  _: 1
                }, 8, ["onClick", "loading", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      width: "500",
      modelValue: _ctx.editAccountDialog,
      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.editAccountDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { title: "Edit account" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_form, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { align: "center" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          class: "pb-0"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_13
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              label: "Name",
                              "hide-details": "",
                              density: "comfortable",
                              modelValue: _ctx.currentTenant.name,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.currentTenant.name) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        (!_ctx.currentTenant?.theme_configuration?.logo || !_ctx.savedLogo)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 0,
                              cols: "12",
                              class: "pb-0"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_file_input, {
                                  color: "primary",
                                  clearable: "",
                                  label: !_ctx.logo.length ? 'Select or drop a logo' : '',
                                  density: "comfortable",
                                  "prepend-icon": "",
                                  modelValue: _ctx.logo,
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.logo) = $event)),
                                  counter: "",
                                  "counter-size-string": "Max 1MB",
                                  "show-size": "",
                                  rules: _ctx.rules,
                                  accept: "image/png"
                                }, {
                                  "append-inner": _withCtx(() => [
                                    (!_ctx.logo.length)
                                      ? (_openBlock(), _createBlock(_component_v_icon, {
                                          key: 0,
                                          color: "primary",
                                          icon: "mdi-image"
                                        }))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }, 8, ["label", "modelValue", "rules"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.currentTenant?.theme_configuration?.logo)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 1,
                              cols: "12"
                            }, {
                              default: _withCtx(() => [
                                (_ctx.savedLogo)
                                  ? (_openBlock(), _createBlock(_component_v_row, {
                                      key: 0,
                                      dense: ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          class: "d-flex justify-center"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_img, {
                                              src: _ctx.savedLogo,
                                              alt: "logo",
                                              width: "200",
                                              height: "64"
                                            }, null, 8, ["src"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          class: "d-flex justify-center"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_btn, {
                                              size: "small",
                                              color: "primary",
                                              variant: "plain",
                                              onClick: _cache[11] || (_cache[11] = ($event: any) => {_ctx.logoCleared = true; _ctx.savedLogo = ''; _ctx.logo = [];})
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("Clear logo")
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_v_col, {
                          cols: "6",
                          class: "pt-0"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              label: "Primary colour",
                              "hide-details": "",
                              density: "comfortable",
                              modelValue: _ctx.primary,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.primary) = $event)),
                              color: "primary"
                            }, {
                              "append-inner": _withCtx(() => [
                                _createVNode(_component_v_menu, {
                                  "close-on-content-click": false,
                                  modelValue: _ctx.primaryDialog,
                                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.primaryDialog) = $event))
                                }, {
                                  activator: _withCtx(({ props }) => [
                                    _createVNode(_component_v_icon, _mergeProps({ color: _ctx.primary }, props, { icon: "mdi-palette" }), null, 16, ["color"])
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_color_picker, {
                                      mode: "hex",
                                      modelValue: _ctx.primary,
                                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.primary) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "6",
                          class: "pt-0"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              label: "Secondary colour",
                              "hide-details": "",
                              density: "comfortable",
                              modelValue: _ctx.secondary,
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.secondary) = $event)),
                              color: "secondary"
                            }, {
                              "append-inner": _withCtx(() => [
                                _createVNode(_component_v_menu, {
                                  "close-on-content-click": false,
                                  modelValue: _ctx.secondaryDialog,
                                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.secondaryDialog) = $event))
                                }, {
                                  activator: _withCtx(({ props }) => [
                                    _createVNode(_component_v_icon, _mergeProps({ color: _ctx.secondary }, props, { icon: "mdi-palette" }), null, 16, ["color"])
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_color_picker, {
                                      mode: "hex",
                                      modelValue: _ctx.secondary,
                                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.secondary) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              clearable: true,
                              label: "Help section URL",
                              density: "comfortable",
                              modelValue: _ctx.helpUrl,
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.helpUrl) = $event)),
                              "persistent-hint": "",
                              hint: "Provide a URL for the custom help section for this account or leave this field blank to use the default"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  color: "primary",
                  onClick: _ctx.saveTenant,
                  loading: _ctx.loading,
                  disabled: _ctx.loading
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Save account ")
                  ]),
                  _: 1
                }, 8, ["onClick", "loading", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}